import * as React from "react";
import { IconX } from "@tabler/icons-react";

export function EventToast({ message, onDismiss }) {
  const toast = React.useRef(null);
  React.useEffect(() => {
    if (!message) return;
    const element = toast.current;
    element.showPopover();
    const timer = window.setTimeout(onDismiss, 4000);
    return () => {
      window.clearTimeout(timer);
      if (element.matches(":popover-open")) element.hidePopover();
    };
  }, [message, onDismiss]);

  if (!message) return null;
  return <div ref={toast} popover="manual" className="event-toast" role="status">
    <span aria-hidden="true">✓</span><p>{message}</p>
    <button type="button" onClick={onDismiss} aria-label="Закрыть уведомление"><IconX aria-hidden="true" /></button>
  </div>;
}
